<template>
    <section>
        <section v-if="isInvalid">
            <div class="alert" v-text="$t('error.invalid_address')"/>
        </section>
    </section>
</template>

<script>
import { matchAddress } from '~/search.js';

export default {
    props: {
        address: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            isInvalid: false,
        };
    },

    async created() {
        try {
            const address = await matchAddress(this.address);

            if (!address) {
                this.isInvalid = true;
                return;
            }

            this.$router.replace(this.$localizeRoute({
                name: 'address',
                params: { address },
            }));
        } catch (error) {
            console.error('Error while matching address:', error);
            this.isInvalid = true;
        }
    },
};
</script>
